var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"pc-brand",attrs:{"to":"/Home","aria-label":_vm.brandName}},[(_vm.logoUrl && !_vm.logoFailed)?_c('img',{attrs:{"src":_vm.logoUrl,"alt":_vm.brandName},on:{"error":function($event){_vm.logoFailed = true}}}):_c('span',[_vm._v(_vm._s(_vm.brandName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }